import Alert from '@mui/lab/Alert';

export function ApiError() {
  return <Alert severity="error">{'Api error'}</Alert>;
}
